import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { AfterCancelSubscriptionPopup } from './AfterCancelSubscriptionPopup';

export const AFTER_CANCEL_SUBSCRIPTION_POPUP = Symbol('AFTER_CANCEL_SUBSCRIPTION');

export const useAfterCancelSubscriptionPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(AFTER_CANCEL_SUBSCRIPTION_POPUP, AfterCancelSubscriptionPopup);
  });

  return useCallback(() => {
    popups.openPopup(AFTER_CANCEL_SUBSCRIPTION_POPUP);
  }, [popups]);
};
